import { Navigate } from "react-router-dom";
import authService from "../../services/authService";

const Logout = () => {
  authService.logout();
  return <Navigate to="/login" />;
};

export default Logout;
